export default __webpack_public_path__ + "static/media/step4.de29f915.svg";